import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { trackBannerClick, trackBannerShow } from './tracking';
import { DailyrentReviewDesktopModal } from '../../components/DailyrentReviewDesktopModal';
import { DailyrentReviewMobileModal } from '../../components/DailyrentReviewMobileModal';
import { useDailyrentReviewModal } from '../../utils/dailyrent/useDailyrentReviewModal';
import { usePlatform } from '../../utils/platform';
import { useDownloadNativeAppUrl } from '../../utils/useDownloadNativeAppUrl';
import { useApplicationContext } from '../../utils/applicationContext';

export const MOBILE_CAMPAIGN = 'Скачайте_приложение,_чтобы_оставить_отзыв_Other_108'; // "_Other" относится к pageType страницы чатов, https://jira.cian.tech/browse/CD-177903

export const DailyrentReviewModalContainer = React.memo(() => {
  const { isOpen, closeModal } = useDailyrentReviewModal();
  const deviceType = useDeviceType();
  const platform = usePlatform();
  const downloadNativeAppUrl = useDownloadNativeAppUrl(MOBILE_CAMPAIGN);
  const { config } = useApplicationContext();

  const isDailyrentReviewModalEnabled = config.get<boolean>('frontend-chats.isDailyrentReviewModalEnabled') || false;

  const isDesktop = deviceType === 'desktop';
  const onBannerClick = React.useCallback(() => trackBannerClick(platform), [platform]);

  const onOpen = React.useCallback(() => {
    trackBannerShow(platform);
  }, [platform]);

  if (!isDailyrentReviewModalEnabled || !isOpen) {
    return null;
  }

  if (isDesktop) {
    return <DailyrentReviewDesktopModal closeModal={closeModal} onDismissClick={closeModal} onOpen={onOpen} />;
  }

  return (
    <DailyrentReviewMobileModal
      closeModal={closeModal}
      downloadNativeAppUrl={downloadNativeAppUrl}
      onDownloadClick={onBannerClick}
      onOpen={onOpen}
    />
  );
});

DailyrentReviewModalContainer.displayName = 'DailyrentReviewModalContainer';
